import PortalRequestsListView from "../../components/portal/PortalRequestsListView";

const PortalTrips = () => {
    //"Ready for Quote", "Out to market", "Broker review" & "Quoted" lists

    return (
        <>
            <section className="home__query">
                <div className="home__query__content wrap portalbg">
                    <PortalRequestsListView
                        stageOptions={["Ready for quote", "Out to market", "Broker review", "Quoted"]}
                    />
                </div>
            </section>
        </>
    );
};

export default PortalTrips;
